<template>
  <div class="page-home">
    <div class="home-side-bar">
      <el-menu default-active="/page-list" router class="home-side-bar-item">
        <el-menu-item index="/home/page-list">
          <i class="el-icon-mobile"></i>
          <span slot="title" class="title">我的模板</span>
        </el-menu-item>
        <!-- <el-menu-item index="/home/my-template">
          <i class="el-icon-document"></i>
          <span slot="title">我的模板</span>
        </el-menu-item> -->
        <!-- <el-menu-item index="/home/page-data">
          <i class="el-icon-menu"></i>
          <span slot="title">我的数据</span>
        </el-menu-item>
        <el-menu-item index="/home/template-list">
          <i class="el-icon-s-shop"></i>
          <span slot="title">创意模板</span>
        </el-menu-item> -->
      </el-menu>
    </div>
    <div class="clearfix my-page-list">
      <router-view class="sub-page"/>
    </div>
  </div>
</template>

<script>
	export default {
	}
</script>

<style lang="scss" scoped>
  .page-home {
    display: flex;
    width: 100%;
    height: 100%;
    background: #0c1226;
    .home-side-bar{
      width: 200px;
      background-color: #161f3f;
      padding-top: 8px;
      z-index: 2;
      .home-side-bar-item {
        background-color: rgb(98,135,241);
        .el-icon-mobile {
          color: #fff;
        }
        .title {
          color: #fff;
        }
        ::v-deep .el-menu-item:hover, .el-menu-item:focus{
          background-color: rgb(54, 105, 248);
        }
      }
    }
    .my-page-list{
      flex: 1;
      height: 100%;
      .sub-page{
        height: 100%;
      }
    }
  }
</style>
